"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var p=()=>({page:{height:"100%",left:"50%",marginLeft:-20,opacity:.5,position:"absolute",textAlign:"center",top:"40%",width:"100%",zIndex:1e3}});exports.default=p;
//# sourceMappingURL=styles.js.map
